export default __webpack_public_path__ + "static/media/Gallery - Clean vs Prince_00.d9e3cfb0.jpg";